export const CORE_APPROVAL_REQUEST = "CORE_APPROVAL_REQUEST";
export const CORE_APPROVAL_SUCCESS = "CORE_APPROVAL_SUCCESS";
export const CORE_APPROVAL_FAILED = "CORE_APPROVAL_FAILED";
